import axios from 'axios';
import { BaseUrl } from '../../server';



export const getFillterPleadings = (page , limit,caseNumber,pleadingNumber ,clientName ,pleadingName,date) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_Fillter_pleadings_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/pleading/filter`,{
            params: {
                page,
                limit,
                caseNumber,pleadingNumber ,clientName ,pleadingName,date
            },
            withCredentials: true,
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_Fillter_pleadings_success',
            payload: {
                pleadings: data.pleadings,
                pagination: data.pagination, // معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_Fillter_pleadings_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};

export const getUserPleadings = (page , limit) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_User_pleadings_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/pleading/user`,{
            params: {
                page,
                limit,
             
            },
            withCredentials: true,
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_User_pleadings_success',
            payload: {
                pleadings: data.pleadings,
                pagination: data.pagination, // معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_User_pleadings_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};



export const getPleading = (id) => async (dispatch) => {
    try {
       
        dispatch({ type: 'get_pleading_request' });

        const { data } = await axios.get(`${BaseUrl}/pleading/${id}`);
        console.log("data",data);
        dispatch({ type: 'get_pleading_success' ,payload:data.pleading});

    } catch (error) {
        dispatch({
            type: "get_pleading_error",
            payload: error.response.data.message,
          });
    }
}